import homeBlockItem from './home-block-item';

export default class HomeAdvantage extends homeBlockItem{
    constructor(data) {
        super(data);
    }
    get key(){
        return 'advantage';
    }
    get type(){
        return 'advantage';
    }
    get numeration(){
        return null;
    }
}